// extracted by mini-css-extract-plugin
module.exports = {"summary_footer":"summary_footer--2dhWT"};